import React from 'react';

const ForbiddenPage = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Forbidden</h1>
      <p>You are not authorized to access this page.</p>
    </div>
  );
};

export default ForbiddenPage;
